export const TestType = {
  MOCA: 'moca',
  MOCA_VISUAL: 'moca_visual',
  MIS: 'mis',
};
